import { getZeroMonetaryValue, multiplyMonetaryValue } from '../../../../utils/monetary-value-utils';
import { getInProgressItem } from './get-in-progress-item';
import { getInProgressItemCount } from './get-in-progress-item-count';
export const getInProgressItemsTotalPrice = () => {
    const inProgressItem = getInProgressItem();
    if (!inProgressItem)
        return getZeroMonetaryValue();
    const inProgressItemCount = getInProgressItemCount();
    return multiplyMonetaryValue(inProgressItem.totalPrice, inProgressItemCount);
};
